export default __webpack_public_path__ + "static/media/lobster.c77d7317.png";